import { styled } from "../../theme";
import { MediaImage } from "../../types";

interface ActivityListContainerProps {
  bg?: MediaImage | string;
}

export const ActivityListContainer = styled.div<ActivityListContainerProps>`
  width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  background: ${({ bg }) => (bg ? (typeof bg === "string" ? bg : `url("${bg.url}")`) : "none")};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    padding-top: 5%;
  }
`;

export const ActivityContainer = styled.div`
  box-sizing: border-box;
  width: calc(100vw * 0.82);
  height: calc((100vw * 0.82) * (9 / 16));
  position: relative;
  z-index: 7;
  align-self: center;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: calc(100vw * 0.9);
    align-self: initial;
    height: initial;
    overflow-y: scroll;
    -webkit-box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
    -moz-box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
    box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
  }
  &.activity-storyline-container .base-activity-container {
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      height: 100%;
    }
  }
`;

export const CloseButtonContainer = styled.div`
  top: 0.1em;
  right: 0.1em;
  z-index: 10;
  position: absolute;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
  }
`;

export const ControlsColumn = styled.div`
  flex-grow: 1;
  min-height: 100%;
  height: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: initial;
  }
`;
